export default __webpack_public_path__ + "static/media/Wasabi Plant Starts.9b0bcebc.PNG";